import { render, staticRenderFns } from "./ValidationNotification.vue?vue&type=template&id=ed32a3ee&scoped=true&"
import script from "./ValidationNotification.vue?vue&type=script&lang=js&"
export * from "./ValidationNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed32a3ee",
  null
  
)

export default component.exports